import React from 'react';
import { Button, token, mediaBreakpointMixin, BUTTON_TYPES, BUTTON_SIZES } from '@zillow/constellation';
import { yieldCallback } from '@zillow/yield-callback';
import styled from 'styled-components';
import { useFormContext } from 'react-hook-form';
import { FieldConfig } from './AffordabilityCalculator.utils.js';
import { trackLabel } from './trackLabel.js';

var MyStyledButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-gpw9jw-0"
})(["position:absolute;top:", "px;right:", "px;z-index:10;@media ", "{display:none;}"], token('spacing.xs'), token('spacing.md'), mediaBreakpointMixin('sm_lte'));
var FullReportButton = function FullReportButton() {
  var form = useFormContext();
  return /*#__PURE__*/React.createElement(MyStyledButton, {
    buttonType: BUTTON_TYPES.secondary,
    type: "button",
    size: BUTTON_SIZES.sm,
    onClick: yieldCallback(function () {
      var values = form.getValues();
      var url = new URL('https://www.zillow.com/mortgage/calculator/affordability/advanced-report/');
      url.searchParams.set('annualIncome', values[FieldConfig.annualIncome.name]);
      url.searchParams.set('monthlyDebts', values[FieldConfig.monthlyDebts.name]);
      url.searchParams.set('customPayment', values[FieldConfig.customPayment.name]);
      url.searchParams.set('monthlyPayment', values[FieldConfig.monthlyPayment.name]);
      url.searchParams.set('monthlyPaymentMax', values[FieldConfig.maximumPayment.name]);
      url.searchParams.set('downPayment', values[FieldConfig.downPayment.name]);
      url.searchParams.set('dti', values[FieldConfig.dti.name]);
      url.searchParams.set('rate', values[FieldConfig.rate.name]);
      url.searchParams.set('term', values[FieldConfig.term.name]);
      url.searchParams.set('includeTaxesInsurance', values[FieldConfig.includeTaxesInsurance.name]);
      url.searchParams.set('propertyTaxRate', values[FieldConfig.propertyTaxRate.name]);
      url.searchParams.set('annualHomeownersInsurance', values[FieldConfig.annualHomeownersInsurance.name]);
      url.searchParams.set('includePMI', values[FieldConfig.includePMI.name]);
      url.searchParams.set('monthlyHOA', values[FieldConfig.monthlyHOA.name]);

      // This happens onClick which is only in window
      // eslint-disable-next-line no-undef
      window.open(url.toString(), '_blank');
      trackLabel('Advanced Report Click');
    })
  }, "Full report");
};
var FullReportButton$1 = FullReportButton;

export { FullReportButton$1 as default };
